import { AmenityGroup } from "../core/api/api.models";
import { Hotel, RoomType, SearchApartmentChecklist } from "./interface";

export const COLORS: string[] = ['#d4fc82', '#decfff', '#ffe56b'];

export const HOTELS: Hotel[] = [{
  name: 'Box Hill',
  image: 'https://localresidential.com.au/wp-content/uploads/2023/10/Resize-image-project-3-1.png',
  location: '517 - 521 Station Street',
  color: '#d4fc82'
}, {
  name: 'Kensington',
  image: 'https://localresidential.com.au/wp-content/uploads/2023/05/2565-Local-%E2%80%93-350-Macaulay-Rd-Kensington_APT504-2.png',
  location: '350 Macaulay Rd',
  color: '#decfff'
}, {
  name: 'South Melbourne',
  image: 'https://localresidential.com.au/wp-content/uploads/2023/05/2565-Local-%E2%80%93-350-Macaulay-Rd-Kensington_APT504-4.png',
  location: '245 Normanby Rd',
  color: '#ffe56b'
}];

const QUESTIONS: SearchApartmentChecklist[] = [{
  name: 'applicant_type',
  title: `Which category best describes you?`,
  type: 'select',
  options: [/*{
    title: 'Employed / Self employed Australian',
    value: 'employed_self_employed_australian'
  }, {
    title: 'New to Australia with visa + employment',
    value: 'new_australia_with_visa_employment'
  }, {
    title: 'Australian student',
    value: 'australian_student'
  }, {
    title: 'Australian citizen - not presently working',
    value: 'australian_citizen_not_working'
  }, {
    title: 'Overseas student',
    value: 'overseas_student'
  }*/]
}, {
  name: 'bedrooms',
  title: 'How many bedrooms would you like?',
  type: 'select',
  value: 1,
  options: [{
    title: '01',
    value: 1
  }, {
    title: '02',
    value: 2
  }, {
    title: '03',
    value: 3
  }]
},  {
  name: 'bathrooms',
  title: 'How many bathrooms do you need?',
  type: 'select',
  value: 1,
  options:  [{
    title: '1 bathroom',
    value: 1
  }, {
    title: '2 bathrooms',
    value: 2
  }/*, {
    title: '3 bathrooms',
    value: 3
  }*/]
}, {
  name: 'lease',
  title: 'Lease length',
  type: 'select',
  value: 1,
  options:  [
  {
    title: '12 months',
    value: 12
  }, {
    title: '24 months',
    value: 24
  }, {
    title: '36 months',
    value: 36
  }]
}, {
  name: 'furnished',
  title: 'Is furnished',
  type: 'select',
  value: 'all',
  options:  [{
    title: 'Yes',
    value: 'yes'
  }, {
    title: 'No',
    value: 'no'
  }, {
    title: 'All',
    value: 'all'
  }]
}, {
  name:'price_range',
  title: 'Price Range',
  type: 'select',
  value: 'all',
  options:  [{
    title: '500 - 700',
    value: '500-700'
  }, {
    title: '700 - 900',
    value: '700-900'
  }, {
    title: '900 - 1100',
    value: '900-1100'
  }, {
    title: '1100 - 1300',
    value: '1100-1300'
  }, {
    title: '1300 - 1500',
    value: '1300-1500'
  }, {
    title: '> 1500',
    value: '>1500'
  }, {
    title: 'All',
    value: 'all'
  }]
}, {
  title: `Who's moving in?`,
  name: 'who_moving_in',
  type: 'select',
  options: [{
    title: 'Just Me',
    value: 'JustMe'
  }, {
    title: 'Housemate/s and me',
    value: 'HousematesAndMe'
  }, {
    title: 'My partner and me',
    value: 'MyPartnerAndMe'
  }, {
    title: 'My kids and me',
    value: 'MyKidsAndMe'
  }, {
    title: 'My partner, kids and me',
    value: 'MyPartnerKidsAndMe'
  }]
}, {
  title: 'Do you have pets?',
  type: 'checkbox',
  // image: 'https://www.livmirvac.com/-/media/Project/Mirvac/LIVMirvac/LIVMirvac/LIVMirvac/images/filter-search/illustration-pets.svg'
  icon: 'pets',
  name: 'have_pets'
}, {
  name: 'start_date',
  title: 'When would you like to move in?',
  type: 'date',
  value: new Date()
}, {
  name: 'need_parking',
  title: 'Do you need a parking space?',
  type: 'checkbox',
  // image: 'https://www.livmirvac.com/-/media/Project/Mirvac/LIVMirvac/LIVMirvac/LIVMirvac/images/filter-search/illustration-car.svg',
  icon: 'directions_car'
}, {
  name: 'need_extra_storage',
  title: 'Do you need extra storage space?',
  type: 'checkbox',
  // image: 'https://www.livmirvac.com/-/media/Project/Mirvac/LIVMirvac/LIVMirvac/LIVMirvac/images/filter-search/illustration-storage.svg',
  icon: 'garage_home'
},/* {
  title: 'Do you need a furnished apartment?',
  type: 'checkbox'
}*/];

const ROOM_TYPES: RoomType[] = [{
  id: 1,
  rooms: [{
    title: '50716',
    id: 1
  }, {
    title: '30206',
    id: 2
  }, {
    title: '30206',
    id: 3
  }]
}, {
  id: 2,
  rooms: [{
    title: '50716',
    id: 4
  }, {
    title: '30206',
    id: 5
  }, {
    title: '30206',
    id: 6
  }]
}, {
  id: 3,
  rooms: [{
    title: '50716',
    id: 7 
  }, {
    title: '30206',
    id: 8
  }, {
    title: '30206',
    id: 9
  }]
}];

export const IMAGES = [
  'https://www.livmirvac.com/-/media/Project/Mirvac/LIVMirvac/Images/Search/Indigo/1%20Bed/1.png',
  'https://www.livmirvac.com/-/media/Project/Mirvac/LIVMirvac/Images/Search/Indigo/1%20Bed/5.png',
  'https://www.livmirvac.com/-/media/Project/Mirvac/LIVMirvac/Images/Search/Indigo/1%20Bed/4.png',
];

export interface OptionItem{
  name: string,
  value?: string,
  amenityGroup?: AmenityGroup
}

export interface FilterItem{
  name: string,
  options: OptionItem[],
  value?: any,
}

const FILTERS: FilterItem[] = [{
  name: 'Floor - Level',
  options: [{
    name: 'Low',
  }, {
    name: 'Medium'
  }, {
    name: 'High'
  }]
}, {
  name: 'Window Direction',
  options: [{
    name: 'Street view'
  }, {
    name: 'Park view'
  }, {
    name: 'Ocean view'
  }, {
    name: 'Terrace view'
  }]
}, {
  name: 'Room Type',
  options: [{
    name: 'Share Room Type',
  }, {
    name: 'Single L with K'
  }]
}, {
  name: 'Size',
  options: [{
    name: 'Medium'
  }, {
    name: 'Large'
  }, {
    name: 'Extra Large'
  }]
}]

export function getHotels(): Hotel[]{
  return HOTELS.map(e => ({...e}))
}

export function getQuestions(): SearchApartmentChecklist[]{
  return QUESTIONS.map(e => ({...e}))
}

export function getSearchResults(): RoomType[]{
  return ROOM_TYPES.map(e => {
    const r = {...e};
    r.images = IMAGES;

    return r;
  })
}

export function getFilters(): FilterItem[]{
  return FILTERS.map(e => ({...e}))
}